import Vue from 'vue'
import ja from 'vee-validate/dist/locale/ja.json'
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import { validProposals } from '@/entities/Appointment'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((key) => {
  const value: any = rules
  extend(key, value[key])
})

localize('ja', ja)

extend('password_strict', {
  validate(value: string) {
    return /^(?=.*?[a-zA-Z])(?=.*?[0-9])[a-zA-Z0-9\-_#$%&!]{8,255}$/.test(value)
  },
  message: 'パスワードは8〜255文字で、英字と数字を各1文字以上含む必要があります（使用可能記号: -_#$%&!）'
})

extend('no_at_sign', {
  validate(value: unknown) {
    const str = String(value ?? '')
    return !str.includes('@')
  },
  message: '名前にメールアドレスは使用できません。'
})

extend('total_size', {
  params: ['limit'],
  validate(value: File[], args: any) {
    const total = value.reduce((sum, file) => sum + file.size, 0)
    return total <= args.limit * 1000 * 1000
  },
  message: '合計ファイルサイズは {limit} MB以下である必要があります。'
})

// 候補日時のうち、開始・終了がそろった候補が1件以上あるかをチェックする
extend('proposals', {
  params: ['proposals'],
  validate(_value: any, args: any) {
    // 候補が1件のときは配列が展開されて要素だけが渡る場合があるため、配列にそろえる
    const proposals = Array.isArray(args.proposals) ? args.proposals : args.proposals ? [args.proposals] : []
    return validProposals(proposals).length > 0
  },
  message: '候補日時を1件以上入力してください。'
})
